// Sección 9.10 — helpers locales para acceso rápido (admin only).
// Solo guarda device_id + first_name (no expone nada sensible).
export const QA_DEVICE_KEY = "pe_quick_device_id";
export const QA_NAME_KEY = "pe_quick_first_name";
export const QA_SETUP_DISMISSED_KEY = "pe_quick_setup_dismissed";

export function getQuickDevice() {
  try {
    const id = localStorage.getItem(QA_DEVICE_KEY);
    const name = localStorage.getItem(QA_NAME_KEY);
    if (!id) return null;
    return { device_id: id, first_name: name || "" };
  } catch { return null; }
}

export function setQuickDevice(device_id, first_name) {
  try {
    localStorage.setItem(QA_DEVICE_KEY, device_id);
    if (first_name) localStorage.setItem(QA_NAME_KEY, first_name);
  } catch {}
}

export function clearQuickDevice() {
  try {
    localStorage.removeItem(QA_DEVICE_KEY);
    localStorage.removeItem(QA_NAME_KEY);
  } catch {}
}

export function markSetupDismissed() {
  try { localStorage.setItem(QA_SETUP_DISMISSED_KEY, "1"); } catch {}
}

export function isSetupDismissed() {
  try { return localStorage.getItem(QA_SETUP_DISMISSED_KEY) === "1"; } catch { return false; }
}

export function clearSetupDismissed() {
  try { localStorage.removeItem(QA_SETUP_DISMISSED_KEY); } catch {}
}

export function deviceLabel() {
  try {
    const ua = navigator.userAgent || "Dispositivo";
    // Try to build a friendly label
    const platform = navigator.platform || "";
    return `${platform} · ${ua.slice(0, 80)}`.slice(0, 120);
  } catch { return "Dispositivo"; }
}
